import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
import { paramsToString } from "../resources/BaseResource";
import { ApplicationStatusId, ApplicationStatus, DocumentStatusId, DocumentStatus, EsignType } from "@ploy-lib/types";
export class AppLoadResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.productName = "";
        this.applicationStatusId = ApplicationStatusId.NotSet;
        this.applicationStatus = ApplicationStatus.NotSet;
        this.documentStatusId = DocumentStatusId.NotSet;
        this.documentStatus = DocumentStatus.NotSet;
        this.applicationStatusDescription = "";
        this.documentStatusDescription = "";
        this.settings = {
            esignType: EsignType.SsnRequired,
            ssnServiceEnabled: false,
            canChooseSigners: false,
            canAddAndDeleteVendorSigners: false,
            canEditIndividualDocumentsForSigners: false,
            disableVendorSigner: false,
            hideVendorSigner: false,
            disableSupplierSigner: false,
            hideSupplierSigner: false,
            disableSignerEditing: false,
            externalUserCanNotAddSigners: false,
            allowEmptyEmail: false,
            showValidPeriod: false,
            canChangeObject: false,
            distributionValues: {},
            alwaysShowProductName: false,
            mustSignDefaultChecked: false,
            showProductInfo: false,
            requireRegnrForEsign: false,
            signersMustHaveContactInfo: false,
            hideSigningActions: false,
            hideDocumentsToSign: false,
            showLastUpdateTime: false,
            useStandardLayoutForDirectUsers: false,
            useIndividualSignerStatus: false,
            productTermsSettings: {
                hasTermsDocument: false,
                termsDocumentName: "",
                productInfoId: 0
            }
        };
    }
    pk() {
        return `${this.id ?? this.applicationNumber}`;
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            invalidIfStale: true,
            dataExpiryLength: Infinity
        };
    }
    static url(urlParams) {
        const { applicationNumber, ...searchParams } = urlParams;
        const url = super.url(urlParams);
        return `${url}${paramsToString(searchParams)}`;
    }
}
AppLoadResource.urlRoot = legacyApiResourceUrl("AppLoad/LoadApplication");
export class AppInitResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.productName = "";
        this.applicationStatusId = ApplicationStatusId.NotSet;
        this.applicationStatus = ApplicationStatus.NotSet;
        this.documentStatusId = DocumentStatusId.NotSet;
        this.documentStatus = DocumentStatus.NotSet;
        this.documentStatusDescription = "";
        this.applicationStatusDescription = "";
    }
    pk() {
        return `${this.id ?? this.productExternalCode}`;
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            invalidIfStale: true,
            dataExpiryLength: Infinity
        };
    }
    static url(urlParams = {}) {
        const { productExternalCode, ...searchParams } = urlParams;
        const url = super.url(urlParams);
        return `${url}${paramsToString(searchParams)}`;
    }
    static init() {
        const instanceFetch = this.fetch.bind(this);
        return this.detail().extend({
            method: "POST",
            fetch(paramsAndBody) {
                const { initialData: body, ...params } = paramsAndBody;
                return instanceFetch(this.url(params), this.getFetchInit(body));
            }
        });
    }
}
AppInitResource.urlRoot = legacyApiResourceUrl("AppLoad/InitProductApplication");
//# sourceMappingURL=AppLoadResource.js.map